import { Type } from 'class-transformer'
import { State } from '../constants/EventState'
import { Room } from './Event/Room'

export class Event {

  public readonly key: string

  public readonly uid: string

  @Type(() => Date)
  public readonly fromDate: Date

  @Type(() => Date)
  public readonly toDate: Date

  public readonly sequence: number

  @Type(() => Date)
  public readonly recurrenceId: Date|null

  public readonly logoFilePath: string

  @Type(() => Room)
  public readonly room: Room

  public readonly description: string

  public readonly summary: string

  public readonly location: string

  constructor(
    key: string,
    uid: string,
    fromDate: Date,
    toDate: Date,
    sequence: number,
    logoFilePath: string,
    room: Room,
    description: string,
    summary: string,
    location: string,
    recurrenceId?: Date,
  ) {
    this.key = key
    this.uid = uid
    this.fromDate = fromDate
    this.toDate = toDate
    this.sequence = sequence
    this.recurrenceId = recurrenceId
    this.logoFilePath = logoFilePath
    this.room = room
    this.description = description
    this.summary = summary
    this.location = location
  }

  public hasRoute(): boolean {
    return this.room && !!this.room.route
  }

  public isOngoing(): boolean {
    return this.fromDate.getTime() < new Date().getTime()
  }

  public isEarlyStart(): boolean {
    const currentTime = new Date().getTime()
    return this.fromDate.getTime() < (currentTime + 10 * 60 * 1000) && this.fromDate.getTime() > currentTime
  }

  public getState(): State {
    if (this.isOngoing()) {
      return State.Negative
    } else if (this.isEarlyStart()) {
      return State.Highlight
    }

    return State.Positive
  }
}
